import { css } from '@linaria/core'
import type { ToastProperties } from '#components/Toast'
import { flattenError, wrapErrorLike } from '#features/ErrorHandling/errorHelpers'
import { toaster } from '#features/Toasts/toaster'
import { ReportHandler } from './ReportHandler'

export const reportButtonClass = css` 
  align-self: flex-end;
  margin-top: 5px;
`

export const toastError = (
  error: unknown,
  { appearance, customMessage }: { appearance?: ToastProperties['appearance']; customMessage?: string } = {},
) => {
  const errorInfo = flattenError(wrapErrorLike(error, customMessage))
  const combinedMessage = errorInfo.map((e, i) => (i === 0 ? e.message : `${e.name}: ${e.message}`)).join('\n')

  const usedAppearance = appearance ?? 'error'
  const hasReport = errorInfo.length > 0 && usedAppearance === 'error'

  try {
    toaster.add({
      title: errorInfo[0].name ?? 'Unknown error',
      appearance: usedAppearance,
      message: combinedMessage,
      visibleInMs: hasReport ? -1 : undefined,
      onClick: hasReport
        ? () => {
            // prevent auto dismissal on click in report dialog
          }
        : undefined,
      children: hasReport ? <ReportHandler errorInfo={errorInfo} /> : undefined,
    })
  } catch (e) {
    console.error('Failed to show toast error:', e)
    console.error('Original error:', error)
  }
  return combinedMessage
}
